module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Ha-Ib.778bd4ab.png";